/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import HowItWorksSectionBase from "@/src/components/Sections/Common/HowItWorksSection/HowItWorksSectionBase";
import PenIcon from "@/src/assets/icons/traffic/toggleable/IconWriting";
import IncomingCallIcon from "@/src/assets/icons/traffic/toggleable/IconIncomingCall";
import HandshakeIcon from "@/src/assets/icons/traffic/toggleable/IconShakeHands";

const HowItWorksSectionSettlement = () => {
  return (
    <HowItWorksSectionBase
      sections={[
        {
          title: "1. Fall beschreiben",
          description: "Sie beschreiben in weniger als 5 Minuten Ihren Fall und laden Ihre Kündigung und den Arbeitsvertrag hoch.",
          icon: PenIcon,
        },
        {
          title: "2. Vorgehen besprechen",
          description: "Wir prüfen Ihren Fall und rufen Sie direkt an, um die nächsten Schritte abzustimmen.",
          icon: IncomingCallIcon,
        },
        {
          title: "3. Gegen Kündigung vorgehen",
          description: "Wir reichen eine Kündigungsschutzklage für Sie ein und kümmern uns um alles Weitere.",
          icon: HandshakeIcon,
        },
      ]}
    />
  );
};

export default HowItWorksSectionSettlement;
